// useIsMobile — returns true when the screen is narrower than 768px (phone/tablet)
// Update the breakpoint here if you ever want to change the cutoff.

import { useState, useEffect } from 'react'

export function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint)

  useEffect(() => {
    function onResize() { setIsMobile(window.innerWidth < breakpoint) }
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [breakpoint])

  return isMobile
}
